<template>
  <div class="header-tools" v-if="isshow">
    <div class="common_header">
      <div class="header-bar">
        <div class="common_header_goback"
             @click="goBack"><span></span></div>
        <div class="common_header_title">{{title || ""}}</div>
        <a class="common_header_personalise-icon"></a>
        <div class="common_header_shortcut">
          <span @click="changeVerticalMenu"></span>
          <div class="header_shortcut">
            <ul class="vertical_shortcut"
                v-show="showMenu">
              <li class="shortcut_item"
                  v-for="(item,index) in items"
                  :key="index">
                <a href="javascript:;"
                   @click="changePage(index,item)"
                   class="shortcut_item_link"><span :style="'background-image:url('+item.src +')'"></span><strong>{{item.name}}</strong></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="header-mask"
         @click="changeVerticalMenu"
         v-show="showMenu"></div>
  </div>
</template>
<style lang="scss" scoped>
.header-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
}
.header-tools {
  position: relative;
}
.common_header {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 44px;
  text-decoration: none;
  color: #252525;
  .header-bar {
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    min-height: 44px;
    background: #fff;
    z-index: 11;
  }
}
.common_header_goback {
  position: absolute;
  width: 40px;
  height: 44px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzRCQTEyN0IzOTcwMTFFODk1OEZCOEVCMEE2QUU1NkUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzRCQTEyN0MzOTcwMTFFODk1OEZCOEVCMEE2QUU1NkUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3NEJBMTI3OTM5NzAxMUU4OTU4RkI4RUIwQTZBRTU2RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3NEJBMTI3QTM5NzAxMUU4OTU4RkI4RUIwQTZBRTU2RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PulQWg8AAAF/SURBVHja7Ni9SsRAEAfwnd1wldiIlqK1td4LiL7CFQaFCHZWgmVqH+GK4FejryA+gPcA9vZ2YnVkd5yAcBLOYJKZ3UWyRbIchPsxSzb/HUBEFfPQKvIxAP89MGn7wPHpuTLOtXoGMdl1WF4rUBug9cX25tpdnufRVHBssXxGhTu0Y6yjs1P6bRTLEo9Lp56ohquLasKcbk5sifvgAMBRRc5oWoau4FIcfRJOaPoQ+i1uwt2H3mZYcdxAdhwnUATHBRTDcQBFcX2B4rg+QC+4rsA9X7gunzpQ1j7S3QuudQWz7HKFjjBbNXNR4QhaYcMCi+LqkwxvtbSX0SWNJVGjAZhQ1T4W8Qk11e2GpkexRP5ZotVBHUmXWwlk122mCZnGAPwV+b3caQxAL0iOsCCK5IpbYkjOwCqC5I787EiJQxMrUurY2YScxNI8Woq0qKZtUpR062NmQB/+RALgqM3/+mgevRhI9imMvVIcewdtqtbH/M8BdOhRD8DA40uAAQDL2thNJDxLvAAAAABJRU5ErkJggg==)
    no-repeat 50%;
  background-position: center;
  background-size: 20px 20px;
  cursor: pointer;
}
.common_header_shortcut {
  //   overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 44px;
  cursor: pointer;
  z-index: 13;
  & > span {
    display: inline-block;
    margin: 12px 12px 12px 10px;
    width: 20px;
    height: 20px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAMCAYAAAG2I8urAAAAAXNSR0IArs4c6QAAAddJREFUSA3VVr1OwzAQto0oqgQPABszD4BY4TVIfwR0aBgQb8ALIAbSoVD1J7wGrFRiAokVsbGwMSAVCXPn4PSSxklMGol6SM539913/jnbjEFzGu0j/GOTUvJACr5Owx0L5SBZVxtqDffbqbel7gNqG6K441ABglN3PyJ9YBHKk2qZXNVdzcJVJAwJzR92IvmgjlLH7RSrBhNPAwPohs508FqPf5wIjQVhOtg0xrgNA1GsQIW5yZ7ZFrVwTA+XIaLm/M4feHsRXUKnDOzSy+s7Lnclxrf59PhwFtPNdMvACn/orTGYEcpWXals0L5JLgOrtnGwx/k54+x51L/c4ZxPq8iUza9+3liss1vY57uUdzTwRJ6kysDi6RBJBhOrNY/vaYJGuQRscrlKtmVMIstQEJucEJenWbxGe0GsmKkodQZ1royExFAGVlVZq3Wy/jn5uknaT4ofkqxWlve73Ys3kk9hcRF4oerhtieXeeqoOWv5g3yrmRoHjIvCC6cQnM95m41vVkybWDa+c+YVeHllxQztNr4hyCDYxLLxNdCFaptY4CvwZo8/PcJgVIBzSPlSXQF5UXjDF716iTbdQ8b4AZxJwb2qZlv2Rn3vOs9L5C/z9d95fwDELzC7i+rQHQAAAABJRU5ErkJggg==)
      no-repeat 50%;
    background-position: center;
    background-size: 20px auto;
  }
}
.common_header_title {
  margin: 0 70px;
  height: 44px;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vertical_shortcut {
  position: absolute;
  top: 53px;
  right: 10px;
  z-index: 10000002;
  border-radius: 4px;
  width: 125px;
  background: rgba(0, 0, 0, 0.9);
  &::before {
    content: "";
    position: absolute;
    top: -5px;
    right: 5px;
    width: 10.5px;
    height: 5px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAJCAYAAAFI2EyZAAAAAXNSR0IArs4c6QAAAIVJREFUKBWVkN0NgDAIhDFu4SauZRyjcSxHcQ57pWdA6ENJWn78OCoiamf3guDpR2uLy2oSEQX9/YmEfs8N9NAFw7CjRfHaYkkbXH11mf7dXmuYcPObhfBymgMJWSCAgDLgDzJPvV0x4mmzAniNPakg981JgEZ7J0N/1aAwodCMAHvpm+ALCRYgJABhMPUAAAAASUVORK5CYII=)
      no-repeat 50%;
    background-size: 100% 100%;
  }
  .shortcut_item {
    display: block;
    position: relative;
    margin-left: 40px;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
    height: 40px;
    line-height: 40px;
    z-index: 1000;
    .shortcut_item_link {
      display: block;
      border: 0;
      width: 100%;
      font-size: 14px;
      color: #fff;
      z-index: 1000;
      text-decoration: none;
      span {
        position: absolute;
        top: 0;
        left: -40px;
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-size: 15px;
        background-position: center;
      }
    }
  }
}
</style>
<script>
export default {
  props: {
    title: {
      type: String,
      value: ""
    },
    tools: {
      type: Boolean,
      value: false
    }
  },
  data () {
    return {
      items: [{
        name: "首页",
        push: "/home",
        icon: "",
        iconSelect: "",
        src: require("../../../static/img/share/menusy-h.png")
      },
      {
        name: "秒杀",
        push: "/seckill/home",
        icon: "",
        iconSelect: "",
        src: require("../../../static/img/share/menums-h.png")
      },
      {
        name: "专场",
        push: "/auction",
        icon: "",
        iconSelect: "",
        src: require("../../../static/img/share/menuzc-h.png"),
      },
      {
        name: "大家拍",
        push: "/everybody",
        icon: "",
        iconSelect: "",
        src: require("../../../static/img/share/menudjp-h.png")
      },
      {
        name: "我的",
        push: "/usercenter",
        icon: "",
        iconSelect: "",
        src: require("../../../static/img/share/menuwd-h.png")
      },
      {
        name: "分享",
        push: "",
        icon: "",
        iconSelect: "",
        src: require("../../../static/img/share/share.png")
      }
      ],
      showMenu: false,
      isshow: true
    }
  },
  methods: {
    goBack () {
      if ((navigator.userAgent.indexOf('MSIE') >= 0) && (navigator.userAgent.indexOf('Opera') < 0)) { // IE
        if (history.length > 0) {
          window.history.go(-1);
        } else {
          this.$router.push({ path: '/home', query: {} })
        }
      } else { //非IE浏览器
        if (navigator.userAgent.indexOf('Firefox') >= 0 ||
          navigator.userAgent.indexOf('Opera') >= 0 ||
          navigator.userAgent.indexOf('Safari') >= 0 ||
          navigator.userAgent.indexOf('Chrome') >= 0 ||
          navigator.userAgent.indexOf('WebKit') >= 0) {
          if (window.history.length > 1) {
            window.history.go(-1);
          } else {
            this.$router.push({ path: '/home', query: {} })
          }
        } else { //未知的浏览器
          window.history.go(-1);
        }
      }
    },
    show () {
      let _this = this;
      _this.WX.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          _this.isshow = false;
        }
      });
    },
    changeVerticalMenu () {
      this.showMenu = !this.showMenu
    },
    changePage (index, item) {
      this.changeVerticalMenu()
      if (index === 5) {
        if (this.$route.push == "/auction/detail" || this.$route.push == "/auction/item" || this.$route.push == "/seckill/item" || this.$route.push == "/mall/item") {
          this.$emit('shareTarget', { share: true, shareType: 1 });
        } else {
          this.$emit('shareTarget', { share: true, shareType: 0 });
        }
        return
      }
      this.$router.push({ path: item.push, query: {} })
    }
  },
  created () {

  },
  mounted () {
    this.show();
  },
  destroyed () {

  }
}
</script>